import { Component, OnInit } from '@angular/core';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { WizardService } from 'src/app/services/wizard/wizard.service';

@Component({
  selector: 'app-start-step',
  templateUrl: './start-step.component.html',
  styleUrls: ['./start-step.component.scss']
})
export class StartStepComponent implements OnInit {
  title: string = "";
  subtitle: string = "";
  analyticsStepName: string = AnalyticsUtility.wizardStepName.start;

  constructor(
    private analyticsService: AnalyticsService,
    public wizardService: WizardService, 
    private confSvc: ConfigService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.title = this.confSvc.getString("startTitle");
    this.subtitle = this.confSvc.getString("startSubtitle");
    this.wizardService.removeAllSelectedWizardOptions();
    this.analyticsService.logCurrentPage(this.analyticsStepName);
  }

}
